const ko = {
  nav: {
    home: "홈", about: "소개", services: "서비스",
    faqs: "자주 묻는 질문", contact: "연락처", consultation: "상담 예약",
  },
  brand: {
    firmName: "전홍민 법률사무소",
    motto: "외국 태생 개인 및 소규모 사업주를 위한 변호사!!",
    photoSoon: "사진 준비 중",
    attorneyTitle: "변호사",
    attorneyName: "전홍민",
    yearsLabel: "인디애나 경력", yearsValue: "22년+",
    languagesLabel: "언어", focusLabel: "전문 분야", focusValue: "유언장 & 신탁",
  },
  hero: {
    h1Line1: "유언·신탁·혼전계약",
    h1Line2: "전문 변호사",
    desc1: "이민자로서 재산 계획 및 가족 법률 문제를 처리하는 것은 독특한 도전을 수반합니다 — 국경을 넘는 자산, 문화적 전통, 언어 장벽, 그리고 비자 상태에 대한 걱정. 저는 여러분과 같은 가정을 도왔기에 이해합니다.",
    desc2: "유언장 작성, 신탁 설립, 그리고 혼전 계약서 서비스를 여러 언어로 제공하며, 이민자의 경험에 깊은 공감을 갖고 있습니다.",
    cta1: "상담 예약하기", cta2: "서비스 보기",
    note: "유언·신탁·혼전계약 전문 · 이민자 가정을 위한 법률 서비스",
  },
  aboutAtty: {
    sectionCalligraphy: "저희 이야기",
    storyTitle1: "저희도 이민자였습니다 —",
    storyTitle2: "여러분의 여정을 이해합니다",
    storyP1: "이 법률사무소는 이민자 커뮤니티를 위해 설립되었습니다 — 국경을 넘어 삶을 일구어 온 가정, 그리고 지금까지 만들어온 모든 것을 보호하고 올바르게 전달하고자 하는 가정을 위해.",
    storyP2: "많은 이민자들이 마주하는 격차가 있습니다: 일반 재산 계획 변호사들은 다문화 가족 구조, 해외 자산, 또는 제2 언어로 법적 시스템을 탐색해야 하는 불안감을 항상 이해하지 못합니다. 저희는 그 격차를 해소합니다.",
    storyP3: "저희는 문자 그대로, 그리고 비유적으로 여러분의 언어를 합니다. 저희 사무소는 유언장 작성, 신탁 설립, 혼전 계약서에 집중하며, 모든 문서는 여러분의 독특한 배경에 대한 이해를 바탕으로 작성됩니다.",
    learnMore: "사무소에 대해 더 알아보기",
    attyCalligraphy: "담당 변호사 소개",
    quote: "\"저는 이민자 가정과 개인이 국경과 문화, 세대를 넘어 그들의 독특한 삶을 반영하는 유언장, 신탁, 그리고 혼전 계약서를 만들 수 있도록 돕습니다. 저의 목표는 간단합니다: 여러분이 이룬 것을 보호하고, 명확함과 안전, 마음의 평화와 함께 전달될 수 있도록 하는 것입니다.\"",
    fullProfile: "전체 프로필 보기",
    commitments: [
      { icon: "ri-translate-2", label: "다국어 서비스", note: "English · 한국어 · 中文" },
      { icon: "ri-global-line", label: "국경 간 전문성", note: "여러 국가에 걸친 자산 및 가족 관계" },
      { icon: "ri-heart-3-line", label: "문화적 감수성", note: "다양한 가족 구조와 전통 존중" },
      { icon: "ri-shield-check-line", label: "이민 상태 고려 계획", note: "체류 신분이 재산 결정에 미치는 영향 이해" },
    ],
  },
  servicesPreview: {
    calligraphy: "전문 분야",
    title1: "세 가지 집중 서비스,",
    title2: "여러분의 이야기를 중심으로",
    consultationCta: "상담 예약하기",
    viewDetails: "클릭하여 자세히 보기",
    services: [
      {
        number: "01", title: "유언장 작성", calligraphy: "최후 유언 및 유서",
        intro: "신중하게 작성된 유언장은 모든 재산 계획의 기초입니다. 이민자 가정에게는 더욱 큰 의미를 가집니다 — 두 나라에 걸친 자산, 대륙을 넘는 대가족, 국경을 초월한 양육권 문제까지. 저희가 모두 다룹니다.",
        details: [
          { title: "이민자 가정을 위한 단순 및 복잡한 유언장", body: "인디애나 주법(IC § 29-1-5-3)에 따르면 유효한 유언장은 유언자가 최소 18세 이상, 정신적 능력을 갖추어야 하며, 유언자의 면전에서 서명하는 두 명의 증인이 필요합니다. 이민자 가정에게 이러한 법적 요건 충족은 시작에 불과합니다 — 저희는 여러분 상황의 전체 복잡성을 다룹니다: 이중 관할권 자산, 문화적으로 중요한 개인 재산, 여러 나라에 걸친 가족 구조. 미국 증권 계좌와 한국 부동산을 함께 보유하거나, 사업 이익과 해외 상속 기대가 겹쳐 있는 경우 등 재산의 모든 층이 명시되고 법적으로 정확하게 표현되도록 합니다. 어떤 자산도 당연시하지 않으며, 어떤 가족도 간과하지 않습니다." },
          { title: "본국에 보유한 자산에 대한 조항", body: "미국 법에 따르면, 미국 유언장은 미국 내에 실제로 위치한 자산만을 관장합니다. 한국, 중국 또는 다른 나라의 부동산, 은행 계좌, 사업 이익은 해당 국가의 법률이 적용되며, 올바르게 이전하기 위해 별도의 법적 문서 — 현지 유언장 또는 그에 상응하는 것 — 가 필요합니다. 저희는 미국 유언장이 해외 자산을 인정하고 필요한 경우 해외 현지 변호사와 조율할 수 있도록 구조를 잡아드립니다. 두 나라에서 자산을 쌓아온 이민자 가정에게 이 조율은 전 세계적으로 효과적인 계획과 국경에서 실패하는 계획의 차이입니다." },
          { title: "미성년 자녀를 위한 후견인 지정", body: "인디애나에서 법원은 IC § 29-3-5에 따라 후견권 확인 시 '아동의 최선 이익' 기준을 적용하지만, 유언장의 후견인 지정은 그 결정에 실질적인 영향을 미칩니다. 이민자 가정의 경우 해외 신뢰할 수 있는 친척을 대체 후견인으로 지명하거나, 미국 내 후견인이 선호되는 조건을 명시하는 경우가 많습니다. 저희는 언어, 문화적 양육, 종교적 가치관, 교육 선호도, 지리적 현실을 고려하여 — 주 후견인과 대체 후견인 모두를 인디애나 법원이 여러분의 의도를 존중하는 데 필요한 구체성으로 작성합니다. 자녀에게 가장 중요한 순간이 왔을 때, 그들이 어디에 있든 상관없이." },
          { title: "신탁과 연계된 유산유입 유언장", body: "유산유입 유언장은 생전에 생전 신탁에 공식적으로 이전되지 않은 자산을 포착하기 위한 인디애나의 법적 메커니즘입니다. 인디애나 법에 따르면, 사망 시 본인 이름으로만 소유된 재산 — 재등록을 잊은 은행 계좌, 차량, 심지어 예상치 못한 상속 — 은 유산유입 유언장에 의해 포착되어 신탁 조건에 따라 배분됩니다. 해외에서 예상치 못한 송금을 받거나, 새로운 미국 자산을 구매하거나, 신탁 편입 과정에서 단계를 놓칠 수 있는 이민자 가정에게 이 안전장치는 매우 중요합니다. 올바르게 조율된 유산유입 유언장과 생전 신탁은 원활하고 빈틈없는 재산 계획을 만듭니다." },
          { title: "디지털 자산 및 해외 계좌 조항", body: "인디애나는 수정 통일 수탁자 디지털 자산 접근법(IC § 32-39)을 채택하여 유언집행인에게 디지털 자산에 접근, 관리, 배분할 법적 권한을 부여합니다 — 단, 재산 계획이 올바르게 구조화된 경우에만 해당됩니다. 명시적인 조항 없이는 유언집행인이 암호화폐 지갑, 해외 PayPal 계좌, 온라인 사업체, 심지어 중요한 금융 기록이 담긴 이메일 계정에 접근하지 못할 수 있습니다. 저희는 접수 시 철저한 디지털 자산 목록을 작성하고, 계정과 접근 자격 증명 프레임워크를 참조하는 집행 가능한 권한 조항을 작성하여 유언집행인이 필요 시 즉시 행동할 법적 권한을 갖도록 합니다. 국내든 해외든 어떤 디지털 자산도 누락되어서는 안 됩니다." },
          { title: "생활 환경 변화에 따른 정기 검토", body: "인디애나 법(IC § 29-1-5-8)은 법적 능력을 유지하는 동안 언제든지 유언장을 취소하거나 수정할 수 있도록 허용합니다 — 유언장을 최신 상태로 유지하는 것은 유언장을 갖는 것만큼 중요합니다. 이민자 가정에게 변화는 끊임없이 일어납니다: 새 자녀가 태어나고, 본국에서 재산을 취득하고, 이민 신분이 바뀌거나, 지명된 유언집행인이 해외로 이주합니다. 이러한 사건들은 처음 작성 시 타당했던 계획을 의도치 않게 훼손할 수 있습니다. 저희는 기존 클라이언트를 위해 구조적인 유언장 검토를 제공합니다 — 일반적으로 3년마다 또는 주요 생활 사건 이후 — 유언 의도가 정확하고, 법적으로 타당하며, 인디애나의 현재 요건과 일치하는지 확인합니다." },
        ],
      },
      {
        number: "02", title: "신탁 설립", calligraphy: "생전 신탁 및 그 이상",
        intro: "신탁은 유언장만으로는 할 수 없는 통제권을 제공합니다. 재산을 비공개로, 유언검인 없이, 국경을 넘어 이전할 수 있어 — 이민자 가정에게 특히 중요합니다.",
        details: [
          { title: "유언검인을 우회하는 취소 가능한 생전 신탁", body: "IC § 29-1에 의해 규정되는 인디애나의 유언검인 절차는 법원이 감독하는 공개 절차로, 6개월에서 1년 이상이 소요될 수 있습니다 — 그 기간 동안 재산 목록, 자산 가치, 가족 배분이 공공 기록의 일부가 됩니다. 올바르게 편입된 취소 가능한 생전 신탁은 이것을 완전히 우회합니다. 신탁 내 자산은 법원 승인 없이 비공개로, 종종 사망 후 몇 주 이내에 수혜자에게 이전됩니다. 한국, 중국 또는 다른 나라에 수혜자가 있는 이민자 가정에게 그 영향은 상당합니다: 해외 가족이 접해 본 적 없는 미국 법적 절차를 거치지 않고도 유산을 받습니다. 핵심은 '올바르게 편입된'입니다 — 저희는 신탁만 작성하는 것이 아니라, 재등록이 필요한 모든 자산을 안내하고 편입 완료를 확인합니다." },
          { title: "장기 자산 보호를 위한 취소 불가 신탁", body: "인디애나 신탁법(IC § 30-4)에 따라 설립된 취소 불가 신탁은 과세 재산에서 자산을 제외하고 대부분의 미래 채권자의 접근을 차단합니다 — 취소 가능한 신탁이 제공할 수 없는 보호입니다. 인디애나는 또한 IC § 30-4-8에 따라 국내 자산 보호 신탁(DAPT)을 허용하여, 특정 조건에서 재량적 수익자로 남아 있을 수 있는 추가적인 채권자 보호를 제공합니다. 해외에서 대규모 상속을 예상하거나, 수십 년간 쌓아온 사업을 보호하거나, 세대를 넘어 계획하는 이민자 가정에게 취소 불가 신탁은 가장 강력한 계획 도구가 될 수 있습니다. 저희는 어떤 구조가 여러분의 목표에 가장 적합한지 권고하기 전에 신중하게 평가합니다." },
          { title: "부양 가족을 위한 특수 요구 신탁", body: "특수 요구 신탁(SNT) — 보충 요구 신탁이라고도 함 — 은 장애를 가진 가족이 메디케이드와 보충적 보안 소득(SSI) 같은 정부 프로그램의 자격을 잃지 않으면서 재정적 지원을 받을 수 있도록 특별히 설계되었습니다. 인디애나 및 연방 법에 따르면, 올바르게 작성된 SNT는 공공 혜택을 대체가 아닌 보충해야 합니다 — 정부가 제공하지 않는 항목과 서비스에 지불할 수 있으며 혜택 자격 상실을 촉발하지 않습니다. 장애가 있는 자녀나 특별한 돌봄이 필요한 노부모를 부양하는 이민자 가정에게, 이 신탁 구조는 종종 가장 중요한 계획 결정입니다. 저희는 모든 적용 가능한 인디애나 및 연방 요건에 따라 1자 및 3자 SNT를 작성합니다." },
          { title: "다세대 재산 이전 계획", body: "인디애나는 주 수준의 재산세나 상속세를 부과하지 않아 다세대 재산 이전에 있어 가장 유리한 주 중 하나입니다. 영구 금지 원칙의 적용도 수정하여 많은 다른 주보다 상당히 오랜 기간 신탁 내에 자산을 유지할 수 있습니다. 저희는 연방 세대 건너뛰기 이전 면세액에 맞게 조정된 세대 건너뛰기 신탁(GST)을 포함한 신탁 구조를 설계하여 이전 세금을 최소화하면서 여러 세대에 걸쳐 자산을 효율적으로 이전합니다. 부동산, 사업체, 또는 투자 포트폴리오를 보유한 이민자 가정에게, 올바르게 구조화된 신탁은 자산과 함께 전달하고자 하는 문화적 가치와 가족의 유산을 보존하면서 세대를 넘어 가족의 자산을 전달할 수 있습니다." },
          { title: "국제 재산 고려 사항 조율", body: "국경 간 재산은 대부분의 미국 변호사가 제공하기 어려운 수준의 조율을 요구합니다. 한국과 중국을 포함한 일부 국가는 미국 신탁이 지시하는 것에 관계없이 의도된 배분을 무효화할 수 있는 강제 상속 제도를 적용합니다. 또한 배우자가 미국 시민이 아닌 경우 무제한 혼인 공제가 적용되지 않으며, 비시민권자 생존 배우자에 대한 이전 시 상속세 유예에 적격 국내 신탁(QDOT)이 필수적일 수 있습니다. 저희는 이러한 국경 간 충돌 지점을 조기에 파악하고, 미국 신탁 구조를 국제 법적 고려사항과 조율하며, 복잡성이 요구하는 경우 해외 재산 변호사와 협력합니다." },
          { title: "지속적인 신탁 관리 지원", body: "재산 계획에서 가장 흔하고 비용이 많이 드는 실수 중 하나는 훌륭하게 작성된 신탁을 만들고 나서 편입에 실패하는 것입니다. 인디애나 법에 따르면, 취소 가능한 생전 신탁은 신탁 이름으로 법적으로 등록된 자산만을 관장합니다. 새로 구입한 집의 재등록을 잊거나, 401(k) 계좌와 생명보험의 수혜자 지정 업데이트를 소홀히 하거나, 해외 상속 수익을 신탁이 아닌 개인 계좌에 두는 것이 흔한 실패 사례입니다. 저희는 신탁 설립 시 자산별 포괄적인 편입 가이드를 제공하고, 후속 편입 검토를 실시하며, 지속적인 관리 질문에 답하여 삶의 모든 단계에서 신탁이 구축 목적을 충실히 수행하도록 합니다." },
        ],
      },
      {
        number: "03", title: "혼전 계약서", calligraphy: "미래를 위한 보호",
        intro: "혼전 계약서는 자산을 보호하고, 기대치를 명확히 하며, 미래를 계획하는 강력한 수단입니다 — 특히 혼인 관계에 국경 간 재산, 사업 이익 또는 가족 의무를 가져오는 이민자 개인과 가정에게 중요합니다.",
        details: [
          { title: "혼전 재산 및 저축에 대한 자산 보호", body: "인디애나 재산 분할 법령(IC § 31-15-7)은 결혼에 가져온 재산의 가치 증가분을 포함한 모든 자산이 이혼 시 공정한 분배 대상이라는 반증 가능한 추정을 만들어냅니다. 혼전 계약서 없이는 법원이 '공정한 것'을 결정하며, 그 결과가 여러분의 기대와 다를 수 있습니다. 올바르게 체결된 혼전 계약서는 지정된 자산에 대해 이 추정을 무효화합니다. 수년 동안 저축을 쌓아왔거나, 본국에 부동산을 보유하고 있거나, 가족 재산을 상속받을 것으로 예상하는 이민자에게, 이 계약은 혼인이 어디서 어떻게 마무리되든 상관없이 그 자산들이 명확하고 합법적으로 보호되도록 합니다." },
          { title: "해외 자산 및 국제 보유에 대한 조항", body: "인디애나 법원은 이 주에서의 혼인 해소에 인디애나 법을 적용하지만, 해외에 위치한 자산은 진정한 집행 과제를 제기합니다: 유효한 인디애나 판결이라도 해당 국가에서 외국 재산에 집행하기 위해 별도의 법적 절차가 필요할 수 있습니다. 저희는 해외 부동산, 외국 은행 계좌, 해외 사업 이익, 예상 상속을 다루는 구체적인 조항을 인디애나에서 집행 가능하면서 관련 외국 관할권에서의 복잡성을 최소화하도록 설계된 언어로 작성합니다. 한국이나 중국에 상당한 자산을 보유한 클라이언트에게는 본국에서의 병행 문서화 필요 여부도 조언합니다." },
          { title: "사업 이익 및 상속권 보호", body: "인디애나 법에 따르면, 결혼 기간 동안 가치가 상승한 사업은 혼인 노력 — 여러분의 시간, 에너지, 또는 혼인 자금 — 이 그 성장에 기여한 경우 일부 분할 대상이 될 수 있습니다. 혼전 계약서는 사업을 처음부터 별도 재산으로 정의하고, 잠재적 혼인 이익을 제한하며, 계약이 테스트될 경우 합의된 가치 평가 방법론을 확립할 수 있습니다. 미국 LLC와 한국의 운영 회사가 결합된 국경 간 사업 구조를 가진 이민자 가정에게 이러한 조항은 국내 및 국제 소유권 차원 모두를 다루어야 합니다. 인디애나 법원이 요구하는 정밀도로 작성합니다." },
          { title: "부채 배분 및 재정 책임 조항", body: "인디애나 법원은 어느 배우자가 의무를 진 것에 관계없이 결혼 기간 중 발생한 부채에 대해 양 배우자를 공동으로 책임질 수 있습니다 — 한 배우자가 다른 배우자 모르게 진 부채도 포함됩니다. 혼전 계약서는 이 위험을 직접 다룹니다: 각 당사자의 기존 부채 배분 방식, 결혼 중 발생한 재정 의무의 개별 또는 공동 처리 방식, 주요 재정 결정 방식을 명시합니다. 해외 학자금 대출, 사업 부채, 또는 대가족에 대한 재정 의무를 가진 이민자 가정에게, 이러한 조항은 법적 보호와 결혼 자체에 도움이 되는 재정적 명확성을 모두 제공합니다." },
          { title: "문화 및 가족 가치를 반영한 맞춤형 조건", body: "인디애나 통일 혼전 계약법(IC § 31-11-3)은 가족 재산에 관한 문화적 전통, 상속 기대, 대가족에 대한 재정 의무를 포함하여 혼전 계약서가 다룰 수 있는 내용에 광범위한 유연성을 허용합니다. 저희 클라이언트 중 많은 분이 이러한 가족 재정 의무가 깊은 의미를 가지는 한국 또는 중국 배경 출신입니다. 저희는 인디애나의 법적 틀 내에서 그 가치들을 존중하여 단순히 법적 최소 요건을 충족하는 것이 아니라, 여러분의 결혼에 가장 중요한 가치와 약속을 진정으로 반영하는 계약을 만들기 위해 작업합니다." },
          { title: "법적으로 정확하고 집행 가능한 문서화", body: "인디애나 통일 혼전 계약법(IC § 31-11-3)에 따르면, 혼전 계약서는 자발적으로 서명하지 않았거나, 사기나 강압의 결과이거나, 한 당사자가 다른 당사자의 재정 상황에 대한 공정하고 합리적인 공개를 받지 못한 경우 무효가 될 수 있습니다. 인디애나 법원은 결혼일 10일 미만 전에 서명되었거나 한 당사자가 독립적인 법률 자문을 받지 못한 혼전 계약서 집행을 거부한 사례가 있습니다. 저희는 이 심사를 견딜 수 있도록 모든 계약서를 구성합니다: 양 당사자를 위한 철저하고 문서화된 재정 공개 일정, 명확한 자발적 체결 선언, 결혼 전 최소 30~60일의 서명 일정, 그리고 대부분의 경우 각 당사자가 독립적인 변호사를 선임한다는 강력한 권고." },
        ],
        ctaExternalUrl: "https://marriagegreencard-junlawfirm.com",
        ctaExternalLabel: "결혼 기반 그린카드 신청",
      },
    ],
  },
  process: {
    calligraphy: "함께하는 여정", title1: "저희가", title2: "함께 일하는 방식",
    steps: [
      { step: "I", title: "상담", desc: "여러분의 언어로 가족, 소원, 그리고 상황에 특유한 국경 간 고려사항에 대한 대화로 시작합니다." },
      { step: "II", title: "맞춤형 전략", desc: "문화적 가치와 재산의 복잡성을 고려하여 — 유언장, 생전 신탁, 또는 둘 다 — 명확한 계획을 설계합니다." },
      { step: "III", title: "전문적 문서 작성", desc: "모든 문서는 법적 정확성을 갖추어 작성되며, 진정한 의도를 반영하고 가장 중요한 순간에 국경을 넘어서도 유효합니다." },
      { step: "IV", title: "지속적인 마음의 평화", desc: "재산 계획이 실행되고 안전하게 보관됩니다. 가족이 보호됩니다. 유산이 여러분의 목소리로 정의됩니다." },
    ],
    finalCalligraphy: "오늘 시작하세요",
    finalTitle1: "가족의 미래는",
    finalTitle2: "계획을 받을 자격이 있습니다",
    finalDesc: "국경을 넘어 삶을 일구셨습니다. 저희가 다음 세대를 위해 그것을 보호할 수 있도록 돕겠습니다 — 여러분의 언어로, 문화와 가족의 독특한 여정에 대한 진심 어린 관심으로 제작됩니다.",
    finalCta1: "상담 예약",
    finalCta2: "(317) 701-2768로 전화",
  },
  footer: {
    desc: "이민자 가정을 위한 재산 계획 — 문화적 감수성, 법적 정확성, 그리고 여러분이 걸어온 여정에 대한 진심 어린 관심으로 제작됩니다.",
    langAvailable: "상담 가능 언어",
    langs: ["한국어 상담 가능", "English Services Available", "提供中文服務"],
    copyright: "전홍민 법률사무소. 모든 권리 보유. · 이민자 커뮤니티 서비스",
    privacy: "개인정보 처리방침", terms: "이용 약관", disclaimer: "면책 조항",
    servicesTitle: "서비스", companyTitle: "회사", resourcesTitle: "리소스",
    willDrafting: "유언장 작성", trustFormation: "신탁 설립", prenuptialAgreement: "혼전 계약서",
    aboutUs: "소개", services: "서비스", faqs: "자주 묻는 질문", contact: "연락처",
    freeConsultation: "상담 예약",
  },
  aboutPage: {
    heroCalligraphy: "저희 소개",
    heroH1Line1: "여러분의 여정을",
    heroH1Line2: "이해하는 변호사",
    heroDesc: "저희는 어딘가에서 이민 온 가정 — 두 세계를 오가며, 두 가지 법적 현실을 헤쳐나가고, 이룬 것을 보호하려는 깊은 바람을 가진 가정을 위해 이 사무소를 세웠습니다.",
    attyCalligraphy: "담당 변호사 소개",
    attyTitle: "변호사",
    attyExp: "인디애나 & 일리노이 주 면허 · IU McKinney 로스쿨 J.D.",
    attyQuote: "\"서울 대기업에서 인디애나 법조계로 — 그 여정은 두 세계를 동시에 살아간다는 것이 어떤 의미인지 제게 가르쳐 주었습니다. 그 경험이 이민자 가정과 사업주를 위한 모든 계획의 바탕이 됩니다.\"",
    attyBio1: "저는 이민자 가정과 소규모 사업주가 국경, 문화, 세대를 넘어 그들의 독특한 삶을 반영하는 유언장, 신탁, 혼전 계약서를 만들 수 있도록 돕습니다. 법률 실무 전, 서울 SK그룹에서 근무하며 국제적 경계를 넘나드는 삶의 도전을 직접 경험했습니다.",
    attyBio2: "인디애나와 일리노이 양 주에서 변호사 면허를 보유하고 있으며, 인디애나 대학교 McKinney 로스쿨에서 J.D., Maurer 로스쿨에서 M.C.L.을 취득했습니다. 모든 클라이언트께 개인적인 관심, 완전한 투명성, 그리고 진정한 관심으로 작성된 계획을 제공합니다.",
    credentials: [
      { label: "J.D.", value: "Indiana University McKinney School of Law" },
      { label: "M.C.L.", value: "Indiana University Maurer School of Law" },
      { label: "면허 취득", value: "인디애나 주 · 일리노이 주" },
      { label: "전문 분야", value: "유언장 작성 · 신탁 설립 · 혼전 계약서" },
      { label: "언어", value: "English · 한국어 · 中文" },
      { label: "이전 경력", value: "SK그룹, 서울, 한국" },
    ],
    storyCalligraphy: "저희의 사명",
    storyTitle1: "저희도 이민자였습니다 —",
    storyTitle2: "여러분이 걸어온 길을 압니다",
    storyP1: "많은 이민자 가정이 수십 년 동안 이 나라에서 삶을 일구어 왔습니다 — 종종 본국에서의 연결, 자산, 책임을 유지하면서. 일반 재산 계획은 이러한 복잡성을 종종 무시합니다. 저희는 그렇지 않습니다.",
    storyP2: "이 사무소는 그 격차를 메우기 위해 설립되었습니다. 엄격한 법률 전문성과 진정한 문화적 감수성 및 다국어 서비스를 결합하여 — 모든 클라이언트가 자유롭게 소통하고, 완전히 이해하고, 완전히 신뢰할 수 있도록.",
    storyP3: "저희는 유언장 작성, 신탁 설립, 혼전 계약서에 집중합니다 — 제대로 수행될 때, 이민자 가정에게 그들의 노력이 마땅히 받아야 할 지속적인 안보를 제공하는 세 분야.",
    atGlanceCalligraphy: "한눈에 보기",
    atGlance: [
      { label: "전문 분야", value: "유언장 작성 · 신탁 설립 · 혼전 계약서" },
      { label: "면허 취득 주", value: "인디애나 & 일리노이" },
      { label: "학력", value: "IU McKinney (J.D.) · IU Maurer (M.C.L.)" },
      { label: "서비스 언어", value: "English · 한국어 · 中文" },
      { label: "초기 상담", value: "여러분의 언어로" },
      { label: "이전 경력", value: "SK그룹, 서울, 한국" },
    ],
    atGlanceQuote: "\"여러분의 가족은 삶을 일구기 위해 바다를 건넜습니다. 저희가 그것이 지속될 수 있도록 하겠습니다.\"",
    valuesCalligraphy: "저희가 지향하는 것",
    valuesTitle1: "이민자 가정을 위한",
    valuesTitle2: "저희의 약속",
    values: [
      { icon: "ri-translate-2", title: "다국어", desc: "여러분의 언어 — 영어, 한국어, 중국어 — 로 소통하여 가장 중요한 순간에 번역에서 길을 잃지 않도록 합니다." },
      { icon: "ri-global-line", title: "국경 간 인식", desc: "여러 국가에 걸친 자산, 가족 관계, 법적 고려사항의 복잡성을 이해합니다." },
      { icon: "ri-heart-3-line", title: "문화적 감수성", desc: "여러분의 문화적 전통과 가족 구조는 저희가 작성하는 모든 문서에 존중받고 반영됩니다." },
      { icon: "ri-shield-check-line", title: "법적 정확성", desc: "유언장 작성 및 신탁 설립의 깊은 전문성 — 모든 문서는 철저하고, 개인화되고, 지속되도록 작성됩니다." },
    ],
    ctaCalligraphy: "시작할 준비가 되셨나요?",
    ctaTitle1: "함께 유산을",
    ctaTitle2: "계획합시다",
    ctaDesc: "여러분의 언어로, 여러분의 이야기를 염두에 두고. 상담이 가족이 이루어온 모든 것을 보호하는 첫 번째 단계입니다.",
    ctaBtn: "대화 시작하기",
  },
  servicesPage: {
    heroCalligraphy: "저희가 하는 일",
    heroH1Line1: "유언, 신탁 &",
    heroH1Line2: "혼전 계약서.",
    heroDesc: "저희는 유언장 작성, 신탁 설립, 혼전 계약서에 전문화되어 있습니다 — 이민자 가정이 국경과 문화를 넘어 미래를 계획할 때 마주하는 도전에 대한 깊은 이해로 작성됩니다. 영어, 한국어, 中文으로 서비스 제공.",
    inquireCta: "서비스 문의하기",
    includedCalligraphy: "포함 사항",
    services: [
      {
        number: "01", title: "유언장 작성", calligraphy: "최후 유언 및 유서",
        intro: "유언장은 여러분의 소원을 가장 직접적으로 표현하는 것입니다 — 이민자 가정에게는 훨씬 더 큰 의미를 가집니다. 두 나라의 자산, 대륙을 넘는 대가족, 국경을 초월하는 양육권 문제. 저희가 모두 다룹니다.",
        desc: "저희는 여러분의 가족, 자산, 개인적 의도에 대한 철저한 대화 — 여러분의 언어로 — 로 시작하여 모든 유언장을 세심하게 접근합니다.",
        features: ["개인 및 부부를 위한 단순 및 복잡한 유언장", "본국에 보유한 자산에 대한 조항", "미성년 자녀를 위한 후견인 지정", "생전 신탁과 연계된 유산유입 유언장", "디지털 자산 조항 및 해외 계좌 지시", "의료 지시서 및 위임장"],
      },
      {
        number: "02", title: "신탁 설립", calligraphy: "생전 신탁 및 그 이상",
        intro: "신탁은 유언장만으로는 할 수 없는 통제권을 제공합니다. 재산을 비공개로, 유언검인 없이, 국경을 넘어 이전할 수 있어 — 가족을 지연, 공개 노출, 의도치 않은 복잡성으로부터 보호합니다.",
        desc: "저희는 생존 배우자 보호, 특별한 필요가 있는 자녀를 위한 지원, 또는 국제 재산 관리 등 여러분의 정확한 의도를 반영하는 신탁을 구성합니다.",
        features: ["유언검인 회피를 위한 취소 가능한 생전 신탁", "자산 보호 및 세금 계획을 위한 취소 불가 신탁", "부양 가족을 위한 특수 요구 신탁", "다세대 재산 이전 계획", "국제 재산 고려 사항 조율", "지속적인 신탁 관리 및 수정 지원"],
      },
      {
        number: "03", title: "혼전 계약서", calligraphy: "미래를 위한 보호",
        intro: "혼전 계약서는 자산을 보호하고, 기대치를 명확히 하며, 미래를 계획하는 강력한 수단입니다 — 특히 혼인 관계에 국경 간 재산, 사업 이익 또는 가족 의무를 가져오는 이민자 개인과 가정에게 중요합니다.",
        desc: "저희는 법적 정확성과 가족의 이야기를 형성하는 문화적 가치를 모두 존중하여 여러분의 독특한 상황을 반영하는 명확하고 집행 가능한 혼전 계약서를 작성합니다.",
        features: ["혼전 재산 및 저축에 대한 자산 보호", "해외 자산 및 국제 보유에 대한 조항", "사업 이익 및 상속권 보호", "부채 배분 및 재정 책임 조항", "문화 및 가족 가치를 반영한 맞춤형 조건", "법적으로 정확하고 집행 가능한 문서화"],
      },
    ],
    ctaCalligraphy: "어디서 시작해야 할지 모르시나요?",
    ctaTitle1: "상담이",
    ctaTitle2: "완벽한 첫 번째 단계입니다",
    ctaDesc: "저희가 상황을 평가하고 유언장, 신탁, 또는 둘 다 — 여러분의 언어로, 가족의 독특한 배경을 고려하여 — 올바른 방법을 이해할 수 있도록 돕겠습니다.",
    ctaBtn: "상담 예약",
  },
  faqsPage: {
    heroCalligraphy: "저희가 답변드립니다",
    heroH1Line1: "가족들이 자주 묻는",
    heroH1Line2: "실질적인 질문들",
    heroDesc: "이민자 가정과 소규모 사업주가 저희에게 가장 많이 묻는 질문들에 대한 솔직한 답변 — 유언장, 신탁, 국경 간 자산, 미래를 위한 계획에 관해.",
    questionsLabel: "개 질문",
    ctaCalligraphy: "아직 질문이 있으신가요?",
    ctaTitle: "모든 상황은 고유합니다",
    ctaDesc: "모든 이민자 가정의 이야기는 다릅니다. 전홍민 변호사님이 부담 없는 상담 중에 — 여러분의 언어로 — 구체적인 질문에 답변해 드릴 것입니다.",
    ctaBtn: "상담 예약",
    categories: [
      {
        category: "이민자 가정", icon: "ri-global-line",
        items: [
          { q: "미국 시민권자나 영주권자가 아니어도 유언장이 필요한가요?", a: "네, 반드시 필요합니다. 이민자 신분은 미국에서 유언장이나 신탁을 만들 권리에 영향을 미치지 않습니다. 계획이 없으면 인디애나 법원이 자산 분배 방식을 결정하며, 그 결과가 가족의 상황을 전혀 반영하지 않을 수 있습니다." },
          { q: "다른 나라에 자산이 있습니다. 미국 유언장이 그것들을 커버할 수 있나요?", a: "미국 유언장은 일반적으로 미국 내 자산을 관장합니다. 해외에 보유한 자산에 대해서는 해당 국가 법률에 따른 별도의 유언장이나 법적 문서가 필요할 수 있습니다. 저희는 미국 재산 계획과 국제적 고려사항을 조율하는 데 도움을 드릴 수 있습니다." },
          { q: "가족이 아직 본국에 살고 있습니다. 수혜자로 포함할 수 있나요?", a: "네. 거주지나 시민권 상태에 관계없이 유언장이나 신탁의 수혜자로 누구든 지명할 수 있습니다. 국경 간 분배가 가능한 한 원활하게 이루어질 수 있도록 적절한 법적 언어를 사용하겠습니다." },
          { q: "비자 소지 중이거나 이민 신분이 진행 중일 때 사망하면 재산은 어떻게 되나요?", a: "재산 계획은 사망 시 비자 또는 이민 신분에 관계없이 유효하고 집행 가능합니다. 다만, 배우자가 미국 시민이 아닌 경우 무제한 혼인 공제가 적용되지 않을 수 있습니다. 이 경우 적격 국내 신탁(QDOT)이 중요한 계획 수단이 될 수 있습니다." },
          { q: "영어가 서툰데 한국어나 중국어로 상담 받을 수 있나요?", a: "물론입니다. 저희는 영어, 한국어, 중국어로 완전한 법률 서비스를 제공합니다. 초기 상담부터 서명까지 모든 과정에서 유언장의 모든 내용을 이해하실 수 있도록 하겠습니다." },
        ],
      },
      {
        category: "유언장 작성", icon: "ri-file-text-line",
        items: [
          { q: "인디애나에서 유언장 없이 사망하면 어떻게 되나요?", a: "인디애나의 무유언 상속법이 재산 분배 방식을 결정합니다. 복잡한 가족 관계를 가진 이민자 가정에게는 유언장 없이 사망하는 것이 특히 문제가 될 수 있습니다. 유언장은 여러분의 목소리가 들릴 수 있도록 합니다." },
          { q: "다른 나라에 사는 사람을 미성년 자녀의 후견인으로 지정할 수 있나요?", a: "유언장에 해외에 사는 사람을 포함하여 후견인 선호를 표현할 수 있습니다. 그러나 인디애나 법원이 최종 후견권 결정 권한을 가지며 아동의 최선 이익을 고려합니다. 주 후견인과 대체 후견인을 모두 지정하는 것을 권장합니다." },
          { q: "여러 나라의 자산을 미국 유언장에서 어떻게 다루나요?", a: "미국 유언장에는 국제 자산을 인정하고 의도를 표현하는 조항을 포함할 수 있습니다. 집행 목적으로는 외국의 자산이 해당 국가 법률에 의해 관장됩니다. 저희는 국제 자산과 조율되는 미국 계획을 세우는 데 도움을 드립니다." },
          { q: "유언장은 얼마나 자주 업데이트해야 하나요?", a: "3-5년마다 또는 중요한 생활 사건 — 결혼, 이혼, 자녀 출생, 자산의 큰 변화 — 후 유언장을 검토하는 것을 권장합니다. 기존 클라이언트를 위한 합리적인 업데이트 서비스를 제공합니다." },
        ],
      },
      {
        category: "신탁 설립", icon: "ri-shield-check-line",
        items: [
          { q: "생전 신탁이 이민자에게 특히 유용한 이유는 무엇인가요?", a: "취소 가능한 생전 신탁은 느리고 비용이 많이 드는 공개 유언검인을 피할 수 있습니다. 해외에 가족이 있는 경우, 이것은 특히 가치가 있습니다. 해외에 거주하는 수혜자들이 긴 미국 유언검인 과정을 탐색할 필요가 없습니다." },
          { q: "미국 시민이 아닌 자녀를 위해 신탁으로 자산을 보호할 수 있나요?", a: "네. 신탁은 시민권이나 거주 국가에 관계없이 어떤 수혜자에게도 자산을 보유하고 분배할 수 있습니다. 자산이 여러분의 소원에 따라 사용될 수 있도록 분배 조건과 일정을 지정할 수 있습니다." },
          { q: "본국으로 귀국하면 신탁은 어떻게 되나요?", a: "미국 취소 가능한 생전 신탁은 일반적으로 제대로 설립된 경우 해외로 이주해도 유효하게 유지됩니다. 그러나 이주가 세금 처리에 영향을 미칠 수 있습니다. 국제 이주 전에 재산 계획을 검토하는 것을 강력히 권장합니다." },
          { q: "취소 가능 신탁과 취소 불가 신탁의 차이는 무엇인가요?", a: "취소 가능 신탁은 언제든지 변경하거나 취소할 수 있습니다 — 완전한 통제권을 유지합니다. 취소 불가 신탁은 일단 설립되면 일반적으로 변경할 수 없습니다. 그 대신 채권자로부터 자산 보호 및 과세 재산 감소와 같은 강력한 보호를 제공합니다." },
        ],
      },
      {
        category: "소규모 사업주", icon: "ri-store-2-line",
        items: [
          { q: "재산 계획 없이 사망하면 소규모 사업은 어떻게 되나요?", a: "계획이 없으면 사업 지분이 유언검인 재산의 일부가 됩니다. 이는 사업이 효과적으로 운영되지 못하거나 불리한 가격에 강제 매각될 수 있는 수개월의 법원 절차를 의미할 수 있습니다. 적절한 재산 계획은 사업이 여러분의 조건에 따라 계속될 수 있도록 합니다." },
          { q: "사업 지분을 신탁에 넣을 수 있나요?", a: "네, 많은 소규모 사업주에게 이것이 매우 권장됩니다. 사업 지분을 취소 가능한 생전 신탁에 배치하면 유언검인 없이 선택한 승계자에게 이전할 수 있습니다. 저희는 사업 설립 문서와 조율하여 법적으로 원활한 이전이 이루어지도록 합니다." },
          { q: "저는 사업의 유일한 소유자입니다. 사업 승계 계획도 필요한가요?", a: "개인 재산 계획과 승계 계획 모두 중요하며, 함께 작동해야 합니다. 개인 재산 계획은 사업 지분을 누가 상속받는지를 다룹니다. 승계 계획은 누가 사업을 운영하고 경영 및 소유권 이전이 어떻게 작동하는지를 파악합니다." },
          { q: "이민자 소규모 사업주로서 알아야 할 독특한 재산 계획 우려사항이 있나요?", a: "몇 가지 중요한 사항이 있습니다. 배우자가 미국 시민이 아닌 경우 무제한 혼인 공제가 적용되지 않을 수 있어 신탁 계획이 더욱 긴급합니다. 본국에 사업 파트너나 투자자가 있다면 국경 간 소유 및 상속 규칙에 신중한 주의가 필요합니다." },
        ],
      },
      {
        category: "혼전 계약서", icon: "ri-hearts-line",
        items: [
          { q: "이민자로서 혼전 계약서가 필요한가요?", a: "혼전에 가져오는 자산, 해외 재산 또는 가족 상속 기대치가 있는 이민자에게 혼전 계약서는 특히 중요할 수 있습니다. 없으면 그 자산이 예상치 못한 방식으로 미국 법에 따라 분할될 수 있습니다. 혼전 계약서는 여러분이 이루어온 것에 대한 통제권을 드립니다." },
          { q: "혼전 계약서가 다른 나라에 보유한 자산도 다룰 수 있나요?", a: "네. 잘 작성된 혼전 계약서는 해외 부동산, 외국 은행 계좌, 해외 사업 이익 및 본국 가족으로부터의 예상 상속을 포함하는 조항을 담을 수 있습니다. 국제적 맥락에서 최대한 집행 가능하도록 언어를 보장합니다." },
          { q: "인디애나에서 혼전 계약서는 법적 효력이 있나요?", a: "네, 혼전 계약서는 혼전 계약 통일법에 따라 인디애나에서 집행 가능합니다. 단, 자발적으로 체결되어야 하고, 양 당사자의 완전한 재정 공개가 있어야 하며, 불합리한 조건이 없어야 합니다. 저희는 법적 심사를 견딜 수 있도록 계약서를 작성합니다." },
          { q: "문화적 전통이나 가족 관습을 혼전 계약서에 반영할 수 있나요?", a: "물론입니다. 많은 클라이언트가 가족 상속, 세대를 통해 전해지는 재산, 또는 특정 가족 재정 의무가 중요한 역할을 하는 문화적 배경을 가지고 있습니다. 인디애나 법이 집행할 수 있는 범위 내에서 그 전통을 존중하기 위해 노력합니다." },
          { q: "결혼 전 얼마나 일찍 시작해야 하나요?", a: "결혼일 최소 2~3개월 전에 절차를 시작하는 것을 권장합니다. 결혼일에 너무 가깝게 서명된 혼전 계약서는 강압을 이유로 이의 제기될 수 있습니다. 일찍 시작하면 양 당사자가 압박 없이 검토, 협상, 서명할 시간을 갖게 됩니다." },
          { q: "예비 배우자도 별도의 변호사가 필요한가요?", a: "강력히 권장되며 — 일부 경우에는 집행 가능성을 위해 필요합니다 — 각 당사자가 계약서를 검토하는 독립적인 법률 자문을 갖는 것이 좋습니다. 필요한 경우 배우자가 상담할 변호사를 추천해 드릴 수 있으며, 이를 통해 절차가 공정하고 계약이 오래 지속될 수 있도록 합니다." },
        ],
      },
    ],
  },
  contactPage: {
    heroCalligraphy: "여정을 시작하세요",
    heroH1Line1: "저희가 여기",
    heroH1Line2: "여러분 곁에 있습니다",
    heroDesc: "여러분의 언어로, 고유한 배경에 깊은 존중을 담아 상담을 진행합니다. 상황을 알려주시면 나아갈 길을 함께 찾겠습니다.",
    badges: [
      { icon: "ri-award-line", text: "초기 상담" },
      { icon: "ri-translate-2", text: "English · 한국어 · 中文" },
      { icon: "ri-shield-check-line", text: "이민자 & 소상공인 특화" },
      { icon: "ri-time-line", text: "1 영업일 내 답변" },
    ],
    infoTitle: "연락처 정보",
    infoAddress: "사무소 주소",
    infoPhone: "전화",
    infoEmail: "이메일",
    infoHours: "운영 시간",
    hoursValue: "월–금: 오전 9시 – 오후 6시\n토: 오전 10시 – 오후 2시",
    whoCalligraphy: "서비스 대상",
    whoTitle: "다음 분들을 위한 전문 서비스:",
    whoItems: [
      "이민자 가정 (비자 또는 시민권 상태 무관)",
      "미래를 계획하는 비시민권자 배우자",
      "두 나라에 자산을 보유한 가정",
      "승계 계획이 없는 소규모 사업주",
      "한국어 또는 중국어로 상담 희망하시는 분",
      "제2 언어로 재산 계획을 준비하시는 분",
    ],
    urgentCalligraphy: "긴급 상담",
    urgentTitle: "긴급 상담 가능",
    urgentDesc: "건강 이슈, 임박한 출국, 또는 긴급한 가족 상황이 있으신 경우 직접 전화하여 우선 일정을 조율하시기 바랍니다.",
    formCalligraphy: "상담",
    formTitle: "상담 신청",
    formSubtitle: "상황을 공유해 주시면 상담 시 더 잘 준비할 수 있습니다. 상담 비용이 발생합니다. 모든 정보는 철저히 비밀이 보장됩니다.",
    successCalligraphy: "접수되었습니다!",
    successMsg: "전홍민 변호사가 직접 문의를 검토하고 1 영업일 내에 선호하신 언어로 연락 드리겠습니다.",
    fieldName: "성명",
    fieldEmail: "이메일 주소",
    fieldPhone: "전화번호",
    fieldPrefLang: "선호 언어",
    fieldImmStatus: "이민 신분",
    fieldSmallBiz: "소규모 사업주이신가요?",
    fieldService: "필요한 서비스",
    fieldOverseas: "해외 자산 보유 여부",
    fieldCountry: "출신국 / 본국",
    fieldMessage: "상황 설명",
    messagePlaceholder: "가족 상황, 자산, 그리고 원하시는 결과를 간략히 설명해 주세요. 틀린 답은 없습니다 — 어떤 정보든 도움이 됩니다...",
    selectPlaceholder: "선택하세요",
    immStatusOptions: [
      "미국 시민권자",
      "영주권자 (그린 카드)",
      "비자 소지자 (H-1B, L-1 등)",
      "신분 보류 중 / 기타",
      "비공개",
    ],
    serviceOptions: [
      "유언장 작성",
      "신탁 설립",
      "유언장 & 신탁 모두",
      "혼전 계약서",
      "사업 승계 계획",
      "아직 잘 모름",
    ],
    yesOpt: "예",
    noOpt: "아니오",
    notSureOpt: "잘 모름",
    errorMsg: "오류가 발생했습니다. 다시 시도하거나 직접 전화해 주세요.",
    sending: "전송 중...",
    submitBtn: "상담 신청서 제출",
    formDisclaimer: "상담 비용이 발생합니다. 모든 정보는 철저히 비밀이 보장됩니다.",
  },
};

export default ko;
